import React from 'react';
import CTA from './CTASection';
import Service from './ServiceSection';
import Project from './ProjectSection';
import Process from './ProcessSection';
import Testimonial from './TestimonialSection';
import ScrollToTop from '../../components/Common/ScrollTop';
import BannerHomeTwelve from '../../components/Banner/BannerHomeTwelve';
import OnepageContactPart from '../../components/Contact/OnepageContact';
import About from './AboutSection';
import ServiceTwo from './ServiceSectionTwo'

const HomeTwelveOnepageMain = () => {

	return (
		<React.Fragment>
			{/* banner-start */}
			<BannerHomeTwelve />
			{/* banner-start */}

			{/* Service-area-start */}
			<ServiceTwo />
			{/* Service-area-end */}

			{/* about-area-start */}
			<About />
			{/* about-area-end */}

			{/* Service-area-start */}
			<Service />
			{/* Service-area-end */}

			{/* Project-area-start */}
			<Project />
			{/* Project-area-end */}

			{/* Testimonial-area-start */}
			<Testimonial />
			{/* Testimonial-area-end */}


			{/* Process-area-start */}
			<Process />
			{/* Process-area-end */}

			{/* CTA-area-start */}
			<CTA />
			{/* CTA-area-end */}

			{/* Contact-area-start */}
			<OnepageContactPart 
				contactSectionClass="rs-contact gray-bg pt-120 md-pt-80"
				contactSubTitleClass="sub-text contact mb-14 orange-color"
				contactSectionTitleClass="title testi-title"
				contactBoxClass="contact-box orange-box"
				submitBtnClass="readon started submit get-ready3"
			/>
			{/* Contact-area-end */}

			{/* scrolltop-start */}
			<ScrollToTop 
				scrollClassName="scrollup oranage"
			/>
			{/* scrolltop-end */}

		</React.Fragment>
	);
}

export default HomeTwelveOnepageMain;